import type { KnowledgeBaseWithIdentity } from '../../../types/knowledge';
import { useI18n } from '../../../i18n/useI18n';
import { formatTimestamp } from '../../../utils/formatUtils';
import './KnowledgeOverviewTab.css';

type KnowledgeOverviewTabProps = {
  database: KnowledgeBaseWithIdentity;
};

export function KnowledgeOverviewTab({ database }: KnowledgeOverviewTabProps) {
  const { locale, translate } = useI18n();
  const description = database.description?.trim() ?? '';

  const formatStatTimestamp = (value?: string | null) =>
    value
      ? formatTimestamp(value, locale)
      : translate('knowledge.notAvailable');

  return (
    <div className="knowledge-database-overview">
      <p
        className={[
          'knowledge-database-page__description',
          description === '' && 'knowledge-database-page__description--empty',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {description !== ''
          ? description
          : translate('knowledge.noDescription')}
      </p>
      <dl className="knowledge-database-page__stats">
        <div className="knowledge-database-page__stat">
          <dt>{translate('knowledge.stats.documents')}</dt>
          <dd>{database.documentCount ?? 0}</dd>
        </div>
        <div className="knowledge-database-page__stat">
          <dt>{translate('knowledge.stats.crawls')}</dt>
          <dd>{database.crawlsCount ?? 0}</dd>
        </div>
        <div className="knowledge-database-page__stat">
          <dt>{translate('knowledge.stats.members')}</dt>
          <dd>{database.memberCount ?? 0}</dd>
        </div>
        <div className="knowledge-database-page__stat">
          <dt>{translate('knowledge.stats.created')}</dt>
          <dd>{formatStatTimestamp(database.created)}</dd>
        </div>
        <div className="knowledge-database-page__stat">
          <dt>{translate('knowledge.stats.lastModified')}</dt>
          <dd>{formatStatTimestamp(database.lastModified)}</dd>
        </div>
      </dl>
    </div>
  );
}
